import styled from "styled-components";

export const StandardToastImageBox = styled.div`
   max-width: 10rem;
   max-height: 10rem;
   margin-right: 4px;
`;
